import {createContext,useState,useContext,useCallback} from 'react';
import {Snackbar,Alert} from '@mui/material';

const SnackbarContext=createContext();
export const useSnackbar=()=>useContext(SnackbarContext);

export const SnackbarProvider=({children})=>{
    const [snackbar,setSnackbar]=useState({
        open:false,
        message:'',
        severity:'info',//'success','error','warning','info'
    });

    const showSnackbar=useCallback((message,severity='info')=>{
        setSnackbar({open:true,message,severity});
    },[]);

    const handleClose=()=>{
        setSnackbar({...snackbar,open:false});
    };

  return (
        <SnackbarContext.Provider value={{showSnackbar}}>
            {children}
            <Snackbar
                open={snackbar.open}
                autoHideDuration={5000}
                onClose={handleClose}
                anchorOrigin={{vertical:'bottom',horizontal:'center'}}>
                <Alert onClose={handleClose} variant="filled" severity={snackbar.severity} sx={{width:'100%',fontSize:'1rem'}}>
                    {snackbar.message}
                </Alert>
            </Snackbar>
        </SnackbarContext.Provider>
    );
};